import log from '@/utils/consolelog'
import permissions from '@/api/modules/permissions'
import * as mutations from './mutations'

const initialState = {
	data: [],
	loading: false,
	error: null
}

export default {
	state: Object.assign({}, initialState),
	getters: {

	},
	mutations: {
		[mutations.SET_PERMISSIONS] (state, value) {
			state.data = value
		},
		[mutations.SET_PERMISSIONS_LOADING] (state, value) {
			state.loading = value
		},
		[mutations.SET_PERMISSIONS_ERROR] (state, value) {
			state.error = value
		},
		[mutations.CLEAR_PERMISSIONS] (state) {
			Object.assign(state, initialState)
		}
	},
	actions: {
		getPermissions ({ commit, state }, { context, user_uid }) {
			commit(mutations.SET_PERMISSIONS_LOADING, true)
			commit(mutations.SET_PERMISSIONS_ERROR, null)
			permissions.getAll(context, user_uid)
				.then(response => {
					log.log('store', 'permissions.getAll OK', response)()
					const permissions = response.body
					commit(mutations.SET_PERMISSIONS, permissions)
				})
				.catch(error => {
					log.error('store', 'permissions.getAll ERROR', error)()
					commit(mutations.SET_PERMISSIONS_ERROR, error)
				})
				.finally(() => {
					commit(mutations.SET_PERMISSIONS_LOADING, false)
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/permissions.js